import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Page as Page$1 } from './Page.js';
import { SlowPage as SlowPage$1 } from './SlowPage.js';
import { FilmstripPageChange } from './PageChange.js';

var PageTracker = /*#__PURE__*/function () {
  function PageTracker(el, items, filmstripMeasurements) {
    var _this = this;

    _classCallCheck(this, PageTracker);

    this.el = el;
    this.items = items;
    this.filmstripMeasurements = filmstripMeasurements;
    /** The current page number, zero-indexed */

    this._currentPage = 0;
    /** The data structure that tracks what pages are at what offsets. Recalculated often. Empty means
    pages have not yet been calculated. */

    this.pageDescriptors = [];

    this.isValidPageIndex = function (i) {
      return Number.isFinite(i) && i >= 0 && i < _this.length;
    };
  }

  _createClass(PageTracker, [{
    key: "resetToFirstPage",
    value: function resetToFirstPage(cause) {
      this.setPage(0, cause);
    }
    /** The canonical way to change a page! */

  }, {
    key: "setPage",
    value: function setPage(request, cause) {
      if (typeof request === 'number' && !this.isValidPageIndex(request)) return;
      var pageChange = new FilmstripPageChange(request, cause, this.currentPageIndex);
      if (pageChange.noChange) return;
      this._currentPage = pageChange.newPage;
      this.el.dispatchEvent(pageChange.createEvent());
    }
  }, {
    key: "getPageByItemIndex",
    value: function getPageByItemIndex(itemIndex) {
      if (!this.items.isValidItemIndex(itemIndex)) return undefined;
      var page;
      this.pageDescriptors.forEach(function (pageDescriptor, i) {
        var firstItemIndex = pageDescriptor.firstItemIndex,
            lastItemIndex = pageDescriptor.lastItemIndex;
        if (itemIndex >= firstItemIndex && itemIndex <= lastItemIndex) page = i;
      });
      return page;
    }
    /** Calculate the offset for every page, accounting for the potential presence of endcaps, and the
        width of the back and forward buttons. */

  }, {
    key: "getOffset",
    value: function getOffset() {
      var pageIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentPageIndex;
      return this.pageDescriptors[pageIndex].offset;
    }
  }, {
    key: "calculate",
    value: function calculate() {
      var PageCalcType = this.items.calculateAllItemWidths ? SlowPage$1 : Page$1;
      var filmstripMeasurements = this.filmstripMeasurements,
          items = this.items; // Let's make those pages

      var previousPage;
      var counter = 0;
      var pages = [previousPage = PageCalcType.create(filmstripMeasurements, items)]; // Notes: when the Filmstrip is inside a hidden div, page.isLast is true on the first page.

      while (!previousPage.isLast) {
        pages.push(previousPage = PageCalcType.create(filmstripMeasurements, items, previousPage)); // This is a backstop for safety.

        if (counter++ > 100) throw new Error('Too many pages!');
      }

      return this.pageDescriptors = pages;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.pageDescriptors.map(function (p) {
        return p.toJSON();
      });
    }
  }, {
    key: "currentPageIndex",
    get: function get() {
      return this._currentPage;
    }
  }, {
    key: "currentPage",
    get: function get() {
      return this.pageDescriptors[this.currentPageIndex];
    }
  }, {
    key: "nextPage",
    get: function get() {
      return this.pageDescriptors[this.currentPageIndex + 1];
    }
  }, {
    key: "lastPageIndex",
    get: function get() {
      return this.length - 1;
    }
  }, {
    key: "length",
    get: function get() {
      return this.pageDescriptors.length;
    }
  }, {
    key: "onFirst",
    get: function get() {
      return this.currentPageIndex === 0;
    }
  }, {
    key: "onLast",
    get: function get() {
      return this.lastPageIndex === this.currentPageIndex;
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.length > 0;
    }
  }]);

  return PageTracker;
}();

export { PageTracker };
